import { Box, Modal } from "@mui/material";
import styles from "../../../../../../components/CommonPopups/CommonPopups.module.css";

import React from "react";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "95%",
    sm: "50%",
    lg: 408,
    xl: 408,
    md: 408,
  },
  bgcolor: "background.paper",
  border: "none",
  boxShadow:
    "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
  p: 3,
};

function InvalidCart(props: any) {
  const { open, onClose, title } = props;
  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: "999999" }}
      >
        <Box sx={style}>
          <div>
            <div
              className={styles.modalTitleForViewLead}
              style={{ textAlign: "center", color: "red" }}
            >
              {title ? title : "Are you sure you want to Cancel?"}
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default InvalidCart;
